/**
 * `#uc3Insight` — design §4 step 9's "generated insight paragraph from templates using only
 * the approved vocabulary" (`GET uc3/diagnosis`'s own `insight: {en, fr}`, already rendered
 * server-side through `apps.intelligence.templates.uc3_insight` — this component only picks
 * the current language, exactly as `values.sentences` is read in `Uc2.tsx`).
 *
 * UC3 launch updates (client, 8 Oct 2026): the limitations list under the paragraph is
 * gone from the panel; the methodology endpoint still serves `limitations`.
 */
import { useTranslation } from 'react-i18next';

export interface InsightProps {
  insight: { en: string; fr: string };
}

export function Insight({ insight }: InsightProps) {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'fr' ? 'fr' : 'en';

  return (
    <div id="uc3Insight" className="intel-insight result-box">
      <div className="result-pad">
        <p>{insight[lang]}</p>
      </div>
    </div>
  );
}

export default Insight;
